import { render, staticRenderFns } from "./MtRadio.vue?vue&type=template&id=db986894&scoped=true&"
import script from "./MtRadio.vue?vue&type=script&lang=js&"
export * from "./MtRadio.vue?vue&type=script&lang=js&"
import style0 from "./MtRadio.vue?vue&type=style&index=0&id=db986894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db986894",
  null
  
)

export default component.exports